import React, { useEffect, useState, useRef } from "react";
import axios from "../../api/axios";
import {
  Row,
  Col,
  Button,
  Form,
  Table,
  Modal,
  Badge,
  Spinner,
  Pagination,
  InputGroup,
  FormControl,
  FormSelect,
  FormLabel,
  Alert,
  Dropdown,
  Card,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import Header from "../../layouts/Header";
import { ArrowLeft, Calculator, CurrencyDollar, FileEarmarkExcel, FileEarmarkSpreadsheet, Receipt, Tag } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Select from 'react-select';
import makeAnimated from "react-select/animated";
import OutletSelect from "../../components/OutletSelect";

const OrdersReport = () => {
  const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
  const [skin, setSkin] = useState(currentSkin);
  const navigate = useNavigate();
  const animatedComponents = makeAnimated();

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      borderRadius: "6px",
      minWidth: "200px",
      borderColor: state.isFocused ? "#80bdff" : "#ced4da",
      boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
      "&:hover": {
        borderColor: state.isFocused ? "#80bdff" : "#ced4da",
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#6c757d",
    }),
  };

  const { userId } = useSelector((state) => state.login);
  const { access } = useSelector((state) => state.login);
  const { email } = useSelector((state) => state.login);
  const [reportAccess, setReportAccess] = useState([]);

  console.log("User Id :", userId);
  console.log("Email :", email);

  console.log("Access :", access);

  useEffect(() => {
    if (Array.isArray(access)) {
      const filteredAccess = access?.filter((perm) =>
        perm?.startsWith("OrdersReport:")
      );
      setReportAccess(filteredAccess);
    }
  }, [access]);

  console.log("Report Access :", reportAccess);

  const getItemTotal = (item) => {
    const basePrice =
      selectedOrder?.order?.coupon?.isMrpDiscount && item.discount > 0
        ? item.mrpRate
        : item.rate;

    const addonsTotal =
      item?.addons?.reduce((sum, addon) => sum + addon.price, 0) || 0;

    return (basePrice + addonsTotal) * item.quantity;
  };


  const accessToken = localStorage.getItem("authToken");
  const [ordersData, setOrdersData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedOutlet, setSelectedOutlet] = useState(null);
  const [selectedOutletName, setSelectedOutletName] = useState('');
  const [outlets, setOutlets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [viewDetailsModal, setViewDetailsModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [subBtnLoading, setSubBtnLoading] = useState(false);
  const [printBtnLoading, setPrintBtnLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState("");
  const [totalRecords, setTotalRecords] = useState("");
  const [ordersGrandTotal, setOrdersGrandTotal] = useState("");
  const [ordersTotalTaxAmt, setOrdersTotalTaxAmt] = useState("");
  const [ordersTotalDiscountAmt, setOrdersTotalDiscountAmt] = useState("");
  const [ordersTotalTaxable, setOrdersTotalTaxable] = useState("");
  const [recordsPerPage, setRecordsPerPage] = useState(25);
  const [errorMsg, setErrorMsg] = useState("");
  const [clicked, setClicked] = useState(false);
  const [orderType, setOrderType] = useState('');
  const [orderStatus, setOrderStatus] = useState('');
  const [downloadBtnLoading, setDownloadBtnLoading] = useState(false);
  const [currentDate, setCurrentDate] = useState(null);

  //Cancel Order States 
  const [cancelBtnLoading, setCancelBtnLoading] = useState(false);
  const [openCancelOrderModal, setOpenCancelOrderModal] = useState(false);
  const [cancelOrderData, setCancelOrderData] = useState({});
  const [refundType, setRefundType] = useState('');
  const [isStockRefund, setIsStockRefund] = useState(false);
  const [reason, setReason] = useState('');
  const [selectedOrderId, setSelectedOrderId] = useState('');
  const [usersList, setUsersList] = useState([]);
  const [selectedAdminUser, setSelectedAdminUser] = useState('');
  const lastPage = Math.ceil(totalRecords / recordsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }

    getOrderData(startDate, endDate, selectedOutlet?.value || "", page, recordsPerPage, searchText, orderType, orderStatus);
  };

  const handleSearchOrders = () => {
    const trimmedSearchText = searchText.trim().toLowerCase();
    if (trimmedSearchText) {
      const filtered = ordersData.filter((order) => {
        const orderNo = order.order?.order_no;
        const orderSequence = order.order?.order_sequence;
        const userName = order.order?.user?.name;
        const orderNoString = String(orderNo);
        const combinedSearchString =
          `${orderSequence}${orderNoString}`.toLowerCase();

        return (
          combinedSearchString.includes(trimmedSearchText) ||
          (typeof userName === "string" &&
            userName.toLowerCase().includes(trimmedSearchText))
        );
      });

      setFilteredData(filtered);
    } else {
      setFilteredData(ordersData);
    }
  };

  const handleSubmit = async () => {
    setSubBtnLoading(true);
    setClicked(true);
    setCurrentPage(1);

    const adjustedStartDate = new Date(startDate?.setHours(23, 59, 59, 999));
    const adjustedEndDate = new Date(endDate?.setHours(23, 59, 59, 999));

    await getOrderData(
      adjustedStartDate,
      adjustedEndDate,
      selectedOutlet?.value || "",
      1,
      recordsPerPage,
      searchText,
      orderType,
      orderStatus
    );
    setSubBtnLoading(false);
  };

  const handleDownloadExcel = async () => {
    setDownloadBtnLoading(true);
    const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
    const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
    getOrderData(adjustedStartDate, adjustedEndDate, selectedOutlet?.value || "", currentPage, recordsPerPage, searchText, orderType, orderStatus, true);
  };

  const getOrderData = async (
    startDate,
    endDate,
    outlet,
    page,
    limit,
    search,
    orderT,
    orderS,
    download
  ) => {
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${accessToken}`,
        "content-type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      };

      let url = `order/getOrdersForAdmin`;

      if (startDate && endDate) {
        url += `?startDate=${startDate.toISOString().split("T")[0]}&endDate=${endDate.toISOString().split("T")[0]}`;
      } else {
        url += `?`;
      }

      if (outlet && outlet !== '') {
        url += `${url.includes('?') ? '&' : '?'}outlet=${outlet}`;
      }

      if (search && search !== "") {
        url += `${url.includes('?') ? '&' : '?'}search=${search}`;
      } else {
        url += `${url.includes('?') ? '&' : '?'}limit=${limit}&page=${page}`;
      }

      if (orderT) {
        url += `${url.includes('?') ? '&' : '?'}orderType=${orderT}`;
      }

      if (orderS) {
        url += `${url.includes('?') ? '&' : '?'}orderStatus=${orderS}`;
      }

      if (download) {
        url += `${url.includes('?') ? '&' : '?'}isDownload=${download}`;
      }

      const response = await axios.get(url, {
        headers,
        responseType: download ? 'blob' : 'json'
      });

      if (download) {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `${selectedOutlet?.label || 'All Outlets'} Orders Report (${endDate.toISOString().split("T")[0]}).xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);

        toast.success('Excel file downloaded successfully!', {
          position: "top-right",
          autoClose: 3000,
          theme: "light"
        });
      } else {
        const ordersData = response?.data?.data?.totalOrdersData || [];
        if (ordersData.length > 0) {
          setOrdersData(ordersData);
          setFilteredData(ordersData);
          setTotalPages(response?.data?.data?.paginationData?.totalPages || 0);
          setTotalRecords(response?.data?.data?.totalOrdersCount || 0);
          setOrdersGrandTotal(response?.data?.data?.ordersGrandTotal || 0);
          setOrdersTotalDiscountAmt(response?.data?.data?.ordersTotalDiscount || 0);
          setOrdersTotalTaxAmt(response?.data?.data?.ordersTotalTaxAmount || 0);
          setOrdersTotalTaxable(response?.data?.data?.ordersTotalTaxable || 0);

          toast.success("Data fetched successfully", {
            position: "top-right",
            autoClose: 3000,
            theme: "light",
          });
        } else {
          toast.info("No records found.", {
            position: "top-right",
            autoClose: 3000,
            theme: "light",
          });
          setFilteredData([]);
        }
      }

    } catch (error) {
      console.error("Error fetching orders data:", error);
      setFilteredData([]);
      if (error?.response) {
        let errorMessage = "";
        if (error.response?.status === 406) {
          errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
        } else if (error.response?.status === 412) {
          errorMessage = error?.response?.data?.data?.message;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.error;
        } else {
          errorMessage = "Something went wrong. Please try again.";
        }

        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    } finally {
      setLoading(false);
      setDownloadBtnLoading(false);
    }
  };

  const viewOrderDetails = (order) => {
    console.log("View Modal :", order);

    setSelectedOrder(order);
    setViewDetailsModal(true);
  };

  const closeModal = () => {
    setViewDetailsModal(false);
    setSelectedOrder(null);
  };

  const getAllOrderDataForReport = async (startDate, endDate, outlet) => {
    try {
      setLoading(true);
      const headers = { Authorization: `Bearer ${accessToken}` };

      let url = `order/getOrdersForAdmin?startDate=${startDate.toISOString().split("T")[0]
        }&endDate=${endDate.toISOString().split("T")[0]}&page=1&limit=10000`;

      if (outlet) {
        url += `&outlet=${outlet}`;
      }

      const response = await axios.get(url, { headers });
      setOrdersGrandTotal(response?.data?.data?.ordersGrandTotal);
      setOrdersTotalDiscountAmt(response?.data?.data?.ordersTotalDiscount);
      setOrdersTotalTaxAmt(response?.data?.data?.ordersTotalTaxAmount);
      setOrdersTotalTaxable(response?.data?.data?.ordersTotalTaxable);
      return response?.data?.data?.totalOrdersData || [];
    } catch (error) {
      console.error("Error fetching orders data for report:", error);
      setOrdersGrandTotal(0);
      setOrdersTotalDiscountAmt(0);
      setOrdersTotalTaxAmt(0);
      setOrdersTotalTaxable(0);
      return [];
    } finally {
      setLoading(false);
    }
  };

  const calculateTotal = () => {
    let total = 0;

    selectedOrder?.orderItems?.forEach((item) => {
      let itemPrice = selectedOrder?.order?.coupon?.isMrpDiscount
        ? item.mrpRate
        : item.rate;
      let addonsTotal = item?.addons?.reduce(
        (sum, addon) => sum + addon?.price,
        0
      );
      total += (itemPrice + addonsTotal) * item?.quantity;
    });

    total += selectedOrder?.order?.platformFees || 0;
    total += selectedOrder?.order?.packingCharges || 0;
    total += selectedOrder?.order?.deliveryCharges || 0;

    return total.toFixed(2);
  };

  const handlePrintReport = async () => {
    setPrintBtnLoading(true);
    const allOrdersData = await getAllOrderDataForReport(
      startDate,
      endDate,
      selectedOutlet?.value || ""
    );
    setPrintBtnLoading(false);

    const grandTotal = allOrdersData
      ?.reduce((total, orderInfo) => {
        return orderInfo?.order?.orderStatus !== "CANCELLED"
          ? total + (orderInfo?.order?.grandTotal || 0)
          : total;
      }, 0)
      .toFixed(2);

    const formatDate = (date) => {
      return new Date(date).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    };

    const formattedStartDate = formatDate(startDate);
    const formattedEndDate = formatDate(endDate);

    const tableContent = `
      <table style="border-collapse: collapse; width: 100%;">
        <thead>
          <tr>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Sr.No</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Order No</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left; width: 120px">User Details</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Order Status</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Date & Time</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Coupon Status</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Coupon Code</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Total</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Tax Amt</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Tot Dis</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left; width: 70px">Overall Total</th>
          </tr>
        </thead>
        <tbody>
          ${allOrdersData.length > 0
        ? allOrdersData
          .map((orderInfo, index) => {
            const userMobile = orderInfo?.order?.user?.mobile;
            const formattedMobile = userMobile?.includes("_deleted_")
              ? `${userMobile.split("_deleted_")[0]} [Deleted]`
              : userMobile;

            return `
                  <tr>
                    <td style="border: 1px solid black; padding: 8px; font-size: 11px">${index + 1
              }</td>
                    <td style="border: 1px solid black; padding: 8px; font-size: 11px">${orderInfo?.order?.order_sequence
              }${orderInfo?.order?.order_no}</td>
                    
                    <td style="border: 1px solid black; padding: 8px; font-size: 10px; word-break: break-word; width: 210px">
                      ${orderInfo?.order?.outletUser
                ? `<span>${orderInfo?.order?.outletUser?.name} [Complimentary Order]</span><br />
                              <span>${orderInfo?.order?.outletUser?.mobile}</span>`
                : orderInfo?.order?.kioskUser
                  ? `<span>${orderInfo?.order?.kioskUser?.name} [Kiosk User]</span><br />
                              <span>${orderInfo?.order?.kioskUser?.phone}</span>`
                  : `<span>${orderInfo?.order?.user?.name}</span><br />
                              <span>${formattedMobile}</span>`
              }

                    </td>
                    <td style="border: 1px solid black; padding: 8px; font-size: 11px">${orderInfo?.order?.orderStatus
              }</td>
                    <td style="border: 1px solid black; padding: 8px; font-size: 11px;">
                      <span>${new Date(
                orderInfo?.order?.createdAt
              ).toLocaleDateString("en-US", {
                day: "numeric",
                month: "numeric",
                year: "numeric",
              })}</span> <br />
                      <span>${new Date(
                orderInfo?.order?.createdAt
              ).toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "numeric",
                hour12: true,
              })}</span>
                    </td>
                    <td style="border: 1px solid black; padding: 8px; font-size: 11px">${orderInfo?.order?.coupon ? "Applied" : "Not Applied"
              }</td>
                    <td style="border: 1px solid black; padding: 8px; font-size: 11px">${orderInfo?.order?.coupon
                ? orderInfo?.order?.coupon?.couponCode
                : "-----"
              }</td>
                    <td style="border: 1px solid black; padding: 8px; font-size: 11px">${orderInfo?.order?.totalTaxable?.toFixed(
                2
              )}</td>
                    <td style="border: 1px solid black; padding: 8px; font-size: 11px">${orderInfo?.order?.totalTaxAmount?.toFixed(
                2
              )}</td>
                    <td style="border: 1px solid black; padding: 8px; font-size: 11px">${orderInfo?.order?.totalDiscount?.toFixed(
                2
              )}</td>
                    <td style="border: 1px solid black; padding: 8px; text-align: end; font-size: 13px; width: 150px">₹. ${orderInfo?.order?.grandTotal?.toFixed(
                2
              )}</td>
                  </tr>
                `;
          })
          .join("") +
        `
              <tr style="font-weight: semibold;">
                <td colspan="10" style="border: 1px solid black; padding: 8px; text-align: right; font-size: 12px">
                  Total (Excluding Tax)
                </td>
                <td style="border: 1px solid black; padding: 8px; text-align: right; font-size: 12px">
                  ₹ ${ordersTotalTaxable?.toFixed(2)}
                </td>
              </tr>
              <tr style="font-weight: semibold;">
                <td colspan="10" style="border: 1px solid black; padding: 8px; text-align: right; font-size: 12px">
                  Total Tax
                </td>
                <td style="border: 1px solid black; padding: 8px; text-align: right; font-size: 12px">
                  ₹ ${ordersTotalTaxAmt?.toFixed(2)}
                </td>
              </tr>
              <tr style="font-weight: semibold;">
                <td colspan="10" style="border: 1px solid black; padding: 8px; text-align: right; font-size: 12px">
                  Total Discount
                </td>
                <td style="border: 1px solid black; padding: 8px; text-align: right; font-size: 12px">
                  ₹ ${ordersTotalDiscountAmt?.toFixed(2)}
                </td>
              </tr>
              <tr style="font-weight: bold;">
                  <td colspan="10" style="border: 1px solid black; padding: 8px; text-align: right; font-size: 12px">Grand Total</td>
                  <td style="border: 1px solid black; padding: 8px; text-align: right; font-size: 12px">₹ ${ordersGrandTotal?.toFixed(
          2
        )}</td>
              </tr>`
        : `<tr>
                <td colspan="11" style="border: 1px solid black; padding: 8px; text-align: center;">No Orders Found</td>
              </tr>`
      }
        </tbody>
      </table>
    `;

    const win = window.open("", "", "width=900,height=600");
    win.document.write(`
      <html>
        <head>
          <title>Orders Report</title>
          <style>
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid black; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; }
          </style>
        </head>
        <body onload="window.print();window.close()">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <h2>Orders Report</h2>
            <span>From [${formattedStartDate} to ${formattedEndDate}]</span>
          </div>
          <div>${tableContent}</div>
        </body>
      </html>
    `);
    win.document.close();
  };

  const handlePrintInvoice = (order) => {
    const win = window.open("", "", "width=820,height=700");

    const arrivalBadge = (() => {
      const status = order?.order?.orderArrivalStatus;
      if (status === "DELAYED") return `<span style="display:inline-flex;align-items:center;gap:6px;background:rgba(220,53,69,0.1);color:#dc3545;border-radius:6px;padding:3px 10px;font-size:11px;font-weight:600;">⏱ Delayed &nbsp;(+${order?.order?.delayedArrival} min)</span>`;
      if (status === "EARLY") return `<span style="display:inline-flex;align-items:center;gap:6px;background:rgba(25,135,84,0.1);color:#198754;border-radius:6px;padding:3px 10px;font-size:11px;font-weight:600;">⚡ Early &nbsp;(-${order?.order?.earlyArrival} min)</span>`;
      return `<span style="display:inline-flex;align-items:center;gap:6px;background:rgba(13,110,253,0.1);color:#0d6efd;border-radius:6px;padding:3px 10px;font-size:11px;font-weight:600;">✓ On Time</span>`;
    })();

    const itemsRows = order.orderItems.map(item => `
    <tr>
      <td style="padding:10px 12px;border-bottom:1px solid #f0f0f0;">
        <div style="font-weight:600;color:#1a1a2e;font-size:13px;">${item.product.name}</div>
        ${item?.addons?.length > 0 ? `<div style="margin-top:4px;">${item.addons.map(a => `<span style="font-size:11px;color:#666;display:block;padding-left:10px;">+ ${a.selectedValue} <span style="color:#888;">(₹${a.price?.toFixed(2)})</span></span>`).join('')}</div>` : ''}
      </td>
      <td style="padding:10px 12px;border-bottom:1px solid #f0f0f0;text-align:center;color:#555;font-size:13px;">${item.quantity}</td>
      <td style="padding:10px 12px;border-bottom:1px solid #f0f0f0;text-align:right;color:#555;font-size:13px;">₹${item.rate?.toFixed(2)}</td>
      <td style="padding:10px 12px;border-bottom:1px solid #f0f0f0;text-align:right;font-weight:600;color:#1a1a2e;font-size:13px;">₹${(item.rate * item.quantity + (item?.addons?.reduce((s, a) => s + a.price, 0) || 0) * item.quantity).toFixed(2)}</td>
    </tr>
  `).join('');

    win.document.write(`<!DOCTYPE html>
  <html>
  <head>
    <title>Invoice #${order.order.order_sequence}${order.order.order_no}</title>
    <style>
      @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=DM+Sans:wght@300;400;500;600&display=swap');
      * { margin:0; padding:0; box-sizing:border-box; }
      body { font-family:'DM Sans',sans-serif; background:#f5f5f0; color:#1a1a2e; }
      .page { max-width:720px; margin:30px auto; background:#fff; border-radius:16px; overflow:hidden; box-shadow:0 8px 40px rgba(0,0,0,0.10); }
      
      /* Header */
      .header { background:linear-gradient(135deg,#1a1a2e 0%,#16213e 60%,#0f3460 100%); padding:36px 40px 28px; position:relative; overflow:hidden; }
      .header::before { content:''; position:absolute; top:-40px; right:-40px; width:180px; height:180px; border-radius:50%; background:rgba(255,255,255,0.05); }
      .header::after  { content:''; position:absolute; bottom:-30px; right:60px; width:100px; height:100px; border-radius:50%; background:rgba(255,255,255,0.04); }
      .store-name { font-family:'Playfair Display',serif; font-size:26px; font-weight:700; color:#fff; letter-spacing:0.5px; }
      .store-sub  { font-size:12px; color:rgba(255,255,255,0.55); margin-top:4px; letter-spacing:1px; text-transform:uppercase; }
      .store-meta { font-size:11.5px; color:rgba(255,255,255,0.65); margin-top:14px; line-height:1.7; }
      .invoice-label { display:inline-block; background:rgba(255,255,255,0.12); border:1px solid rgba(255,255,255,0.2); color:#fff; font-size:11px; font-weight:600; letter-spacing:2px; text-transform:uppercase; padding:5px 14px; border-radius:20px; margin-top:16px; }
      
      /* Meta strip */
      .meta-strip { display:grid; grid-template-columns:repeat(3,1fr); gap:0; border-bottom:1px solid #f0f0f0; }
      .meta-cell  { padding:18px 22px; border-right:1px solid #f0f0f0; }
      .meta-cell:last-child { border-right:none; }
      .meta-label { font-size:10px; font-weight:600; color:#999; text-transform:uppercase; letter-spacing:1px; margin-bottom:5px; }
      .meta-value { font-size:13px; font-weight:600; color:#1a1a2e; }
      .meta-value.highlight { color:#0f3460; }
      
      /* Status pill */
      .status-pill { display:inline-flex; align-items:center; gap:5px; padding:3px 10px; border-radius:20px; font-size:11px; font-weight:700; letter-spacing:0.5px; }
      .status-COMPLETED,.status-DELIVERED { background:#e8f7ef; color:#198754; }
      .status-CONFIRMED { background:#e8f0fe; color:#4361ee; }
      .status-CANCELLED { background:#fce8e8; color:#dc3545; }
      .status-default   { background:#f0f0f0; color:#555; }
      
      /* Customer + Order info */
      .info-grid { display:grid; grid-template-columns:1fr 1fr; gap:0; border-bottom:1px solid #f0f0f0; }
      .info-box  { padding:20px 24px; }
      .info-box:first-child { border-right:1px solid #f0f0f0; }
      .info-box h4 { font-size:10px; font-weight:700; color:#aaa; text-transform:uppercase; letter-spacing:1.5px; margin-bottom:10px; }
      .info-box p  { font-size:13px; color:#333; line-height:1.7; }
      .info-box strong { color:#1a1a2e; }
      
      /* Items table */
      .items-section { padding:24px; }
      .section-title { font-family:'Playfair Display',serif; font-size:15px; font-weight:600; color:#1a1a2e; margin-bottom:14px; padding-bottom:10px; border-bottom:2px solid #1a1a2e; display:flex; justify-content:space-between; align-items:center; }
      table { width:100%; border-collapse:collapse; }
      thead tr { background:#f8f8f6; }
      thead th { padding:10px 12px; font-size:10px; font-weight:700; color:#888; text-transform:uppercase; letter-spacing:1px; text-align:left; }
      thead th:last-child, thead th:nth-child(3), thead th:nth-child(2) { text-align:right; }
      thead th:nth-child(2) { text-align:center; }
      
      /* Totals */
      .totals { border-top:2px solid #f0f0f0; margin-top:4px; }
      .total-row { display:flex; justify-content:space-between; padding:7px 12px; font-size:13px; color:#555; }
      .total-row.discount { color:#dc3545; }
      .total-row.tax      { color:#f59e0b; }
      .grand-total { background:linear-gradient(135deg,#1a1a2e,#0f3460); margin:16px 24px 24px; border-radius:12px; padding:18px 20px; display:flex; justify-content:space-between; align-items:center; }
      .grand-total span:first-child { font-size:13px; color:rgba(255,255,255,0.7); font-weight:500; letter-spacing:0.5px; }
      .grand-total span:last-child  { font-family:'Playfair Display',serif; font-size:22px; font-weight:700; color:#fff; }
      
      /* Arrival */
      .arrival-section { margin:0 24px 20px; padding:14px 18px; background:#f8f8f6; border-radius:10px; display:flex; align-items:center; justify-content:space-between; }
      .arrival-label { font-size:11px; font-weight:700; color:#999; text-transform:uppercase; letter-spacing:1px; }
      
      /* Footer */
      .footer { background:#f8f8f6; padding:18px 24px; display:flex; justify-content:space-between; align-items:center; border-top:1px solid #eee; }
      .footer-left  { font-size:11px; color:#aaa; }
      .footer-right { font-size:11px; color:#aaa; text-align:right; }
      .thank-you { text-align:center; padding:20px; font-family:'Playfair Display',serif; font-size:15px; color:#1a1a2e; letter-spacing:0.5px; border-top:1px solid #f0f0f0; }
      
      @media print {
        body { background:#fff; }
        .page { box-shadow:none; margin:0; border-radius:0; }
      }
    </style>
  </head>
  <body onload="window.print();window.close()">
    <div class="page">
      
      <!-- Header -->
      <div class="header">
        <div class="store-name">${order?.orderStatusLogs[0]?.outlet?.name || 'XPANSE CAFE'}</div>
        <div class="store-sub">Premium Cafe & Restaurant</div>
        <div class="store-meta">
          ${order?.orderStatusLogs[0]?.outlet?.address || ''}<br/>
          GSTIN: ${order?.orderStatusLogs[0]?.outlet?.gstin || 'N/A'} &nbsp;|&nbsp; Tel: ${order?.orderStatusLogs[0]?.outlet?.phone || 'N/A'}
        </div>
        <div class="invoice-label">Tax Invoice</div>
      </div>

      <!-- Meta Strip -->
      <div class="meta-strip">
        <div class="meta-cell">
          <div class="meta-label">Invoice No</div>
          <div class="meta-value highlight">#${order?.order?.order_sequence}${order?.order?.order_no}</div>
        </div>
        <div class="meta-cell">
          <div class="meta-label">Date & Time</div>
          <div class="meta-value">${new Date(order?.order?.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}</div>
          <div style="font-size:11px;color:#888;margin-top:2px;">${new Date(order?.order?.createdAt).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</div>
        </div>
        <div class="meta-cell">
          <div class="meta-label">Order Status</div>
          <div style="margin-top:4px;">
            <span class="status-pill status-${order?.order?.orderStatus || 'default'}">${order?.order?.orderStatus || 'N/A'}</span>
          </div>
          <div style="font-size:11px;color:#888;margin-top:5px;">${order?.order?.paymentGatewayProvider || order?.order?.paymentMode || 'N/A'}</div>
        </div>
      </div>

      <!-- Customer + Order Info -->
      <div class="info-grid">
        <div class="info-box">
          <h4>Bill To</h4>
          <p>
            <strong>${order?.order?.outletUser?.name || order?.order?.kioskUser?.name || order?.order?.user?.name || 'Walk-in Customer'}</strong><br/>
            ${order?.order?.outletUser?.mobile || order?.order?.kioskUser?.phone || order?.order?.user?.mobile || 'N/A'}<br/>
            ${order?.order?.coupon ? `<span style="font-size:11px;background:#e8f7ef;color:#198754;padding:2px 8px;border-radius:4px;margin-top:4px;display:inline-block;">🏷 Coupon: ${order?.order?.coupon?.couponCode}</span>` : ''}
          </p>
        </div>
        <div class="info-box">
          <h4>Order Info</h4>
          <p>
            <strong>Type:</strong> ${order?.order?.ordersType || order?.order?.paymentMode || 'N/A'}<br/>
            <strong>Pickup:</strong> ${order?.order?.pickupOption || 'N/A'}<br/>
            <strong>Payment:</strong> ${order?.order?.paymentStatus || 'N/A'}
          </p>
        </div>
      </div>

      <!-- Items Table -->
      <div class="items-section">
        <div class="section-title">
          <span>Order Items</span>
          <span style="font-size:12px;font-weight:500;font-family:'DM Sans',sans-serif;color:#888;">${order.orderItems.length} item${order.orderItems.length !== 1 ? 's' : ''}</span>
        </div>
        <table>
          <thead>
            <tr>
              <th>Description</th>
              <th style="text-align:center;">Qty</th>
              <th style="text-align:right;">Unit Price</th>
              <th style="text-align:right;">Amount</th>
            </tr>
          </thead>
          <tbody>
            ${itemsRows}
          </tbody>
        </table>

        <!-- Totals -->
        <div class="totals">
          ${order?.order?.platformFees ? `<div class="total-row"><span>Platform Fees</span><span>₹${Number(order.order.platformFees).toFixed(2)}</span></div>` : ''}
          ${order?.order?.packingCharges ? `<div class="total-row"><span>Packing Charges</span><span>₹${Number(order.order.packingCharges).toFixed(2)}</span></div>` : ''}
          ${order?.order?.deliveryCharges ? `<div class="total-row"><span>Delivery Charges</span><span>₹${Number(order.order.deliveryCharges).toFixed(2)}</span></div>` : ''}
          <div class="total-row"><span>Subtotal (Taxable)</span><span>₹${order?.order?.totalTaxable?.toFixed(2)}</span></div>
          <div class="total-row discount"><span>Discount</span><span>− ₹${order?.order?.totalDiscount?.toFixed(2)}</span></div>
          <div class="total-row tax"><span>Tax (${order.order.taxDetails?.length ? order.order.taxDetails.map(t => t.name + ' @' + t.rate + '%').join(', ') : 'Inclusive'})</span><span>+ ₹${order?.order?.totalTaxAmount?.toFixed(2)}</span></div>
        </div>
      </div>

      <!-- Grand Total -->
      <div class="grand-total">
        <span>GRAND TOTAL</span>
        <span>₹${order?.order?.grandTotal?.toFixed(2)}</span>
      </div>

      <!-- Arrival Status -->
      <div class="arrival-section">
        <span class="arrival-label">Arrival Status</span>
        ${arrivalBadge}
      </div>

      <!-- Thank You -->
      <div class="thank-you">Thank you for choosing ${order?.orderStatusLogs[0]?.outlet?.name || 'us'}! 🙏</div>

      <!-- Footer -->
      <div class="footer">
        <div class="footer-left">Terms & Conditions Apply<br/>This is a computer generated invoice</div>
        <div class="footer-right">Powered by Xpanse POS<br/>${order?.orderStatusLogs[0]?.outlet?.name || 'XPANSE CAFE'}</div>
      </div>

    </div>
  </body>
  </html>`);
    win.document.close();
  };

  const handleOpenCancelOrderModal = (orderData) => {
    setOpenCancelOrderModal(true);
    setCancelOrderData(orderData);
    setSelectedOrderId(orderData?.order?._id);
  }

  const handleCancelNormalOrder = async (e) => {
    e.preventDefault();
    setCancelBtnLoading(true);
    try {
      console.log("Normal Order Cancel Api");
      const headers = {
        Authorization: `Bearer ${accessToken}`
      }
      let reqBody = {
        refundType: refundType,
        reason: reason,
        isStockRefund: isStockRefund,
        _id: selectedOrderId,
        approval: selectedAdminUser,
        userId: userId
      }
      console.log("Reeqqq Body :", reqBody);
      const response = await axios.put('order/cancel/admin/new', reqBody, { headers });
      console.log("Response :", response);
      getOrderData(
        startDate,
        endDate,
        selectedOutlet?.value || "",
        currentPage,
        recordsPerPage,
        searchText,
        orderType,
        orderStatus
      );
      toast.success(response?.data?.data?.message, {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    } catch (error) {
      console.log("Error in Normal Order :", error);
      if (error?.response) {
        let errorMessage = '';
        if (error.response?.status === 406) {
          errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
        } else if (error.response?.status === 403) {
          errorMessage = error?.response?.data?.data?.message || error?.response?.data?.error;
        }
        else if (error.response?.status === 412) {
          errorMessage = error?.response?.data?.data?.message;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.error;
        }

        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
        });
      }
    } finally {
      setCancelBtnLoading(false);
    }
  }

  const handleCancelSubsOrder = async (e) => {
    e.preventDefault();
    setCancelBtnLoading(true);
    try {
      console.log("Subscription Order Cancel Api");

      const headers = {
        Authorization: `Bearer ${accessToken}`
      }
      let reqBody = {
        refundType: refundType,
        reason: reason,
        approval: selectedAdminUser,
        isStockRefund: isStockRefund,
        _id: selectedOrderId
      }
      console.log("Reeqqq Body :", reqBody);
      const response = await axios.put('order/cancelOrderAdmin', reqBody, { headers });
      console.log("Response :", response);
      getOrderData(
        startDate,
        endDate,
        selectedOutlet?.value || "",
        currentPage,
        recordsPerPage,
        searchText,
        orderType,
        orderStatus
      );
      toast.success(response?.data?.data?.message, {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    } catch (error) {
      console.log("Error In Subscription :", error);
      if (error?.response) {
        let errorMessage = '';
        if (error.response?.status === 406) {
          errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
        }
        else if (error.response?.status === 412) {
          errorMessage = error?.response?.data?.data?.message;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.error
        }

        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    } finally {
      setCancelBtnLoading(false);
    }
  }

  const handleCloseCancelOrderModal = () => {
    setOpenCancelOrderModal(false);
    setRefundType('');
    setIsStockRefund();
    setSelectedOrderId('');
    setReason('');
  }

  useEffect(() => {
    const now = new Date();
    const currentD = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );
    const start = new Date(currentD.setHours(23, 59, 59, 999));
    setCurrentDate(start);
    console.log("Current date :", start);

  }, [])

  useEffect(() => {
    const fetchOrderData = () => {
      if (searchText === "") {
        const now = new Date();
        const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const currentDate = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate()
        );
        const start = new Date(currentDate.setHours(23, 59, 59, 999));
        const end = new Date(now.setHours(23, 59, 59, 999));

        setStartDate(start);
        setEndDate(end);
      }
    };

    fetchOrderData();
  }, []);

  useEffect(() => {
    console.log("hello");
    if (clicked) {
      getOrderData(
        startDate,
        endDate,
        selectedOutlet?.value || "",
        1,
        recordsPerPage,
        searchText,
        orderType,
        orderStatus
      );
    }

  }, [recordsPerPage]);

  useEffect(() => {
    getAdminUsersList();
  }, []);

  const renderPaginationItems = () => {
    if (totalPages > 15) {
      return (
        <>
          {currentPage > 3 && (
            <Pagination.Item onClick={() => handlePageChange(1)}>
              1
            </Pagination.Item>
          )}
          {currentPage > 4 && <Pagination.Ellipsis />}

          {Array.from({ length: 5 }, (_, i) => {
            const pageNumber = currentPage > 3 ? currentPage - 2 + i : i + 1;
            if (pageNumber <= totalPages) {
              return (
                <Pagination.Item
                  key={pageNumber}
                  active={pageNumber === currentPage}
                  onClick={() => handlePageChange(pageNumber)}
                >
                  {pageNumber}
                </Pagination.Item>
              );
            }
            return null;
          })}

          {currentPage < totalPages - 3 && <Pagination.Ellipsis />}
          {currentPage < totalPages - 2 && (
            <Pagination.Item onClick={() => handlePageChange(totalPages)}>
              {totalPages}
            </Pagination.Item>
          )}
        </>
      );
    } else {
      return Array.from({ length: totalPages }, (_, i) => (
        <Pagination.Item
          key={i + 1}
          active={i + 1 === currentPage}
          onClick={() => handlePageChange(i + 1)}
        >
          {i + 1}
        </Pagination.Item>
      ));
    }
  };

  const getStatusBadgeColor = (status) => {
    switch (status) {
      case "COMPLETED":
        return "success";
      case "DELIVERED":
        return "primary";
      case "CONFIRMED":
        return "secondary";
      case "READY-TO-PICK":
        return "warning";
      case "CANCELLED":
        return "danger";
      default:
        return "dark";
    }
  };

  const getAdminUsersList = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.get("admin-user-management", { headers });
      console.log("Response of admin users :", response.data.data.dbResponse);

      if (response?.data?.status === true) {
        response?.data?.data?.dbResponse.forEach((item, index) => {
          item.serialNumber = index + 1;
        });
        setUsersList(response?.data?.data?.dbResponse);
      }
    } catch (error) {
      console.log("Error in Fetching Admin Users :", error);

      // if (error.response && error.response?.data?.status === false) {
      //     let errorMessage = error.response.data.error;
      //     toast.error(errorMessage, {
      //         position: "top-right",
      //         autoClose: 3000,
      //         theme: "colored",
      //     });
      // }
    }
  };

  const adminUserOptions = usersList?.map((users) => ({
    value: users?._id,
    label: users?.name,
  }));

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div
        className={`main main-app p-3 p-lg-4 ${skin === "dark" ? "bg-dark text-light" : "bg-light"
          }`}
      >
        <div>
          <div className={`card ${skin === "dark" ? "bg-dark-dark" : ""} border-0 shadow-sm`}>
            <div className="card-header bg-white border-0 py-3 d-flex justify-content-between align-items-center">
              <div>
                <h4 className="mb-0 fw-bold d-inline-block">
                  <i className="bi bi-bag me-2"></i>ORDERS REPORT
                </h4>
              </div>
              <div>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => navigate('/reports/all-reports')}
                  className="me-3 d-flex align-items-center fw-semibold"
                  style={{ height: '38px' }}
                >
                  <ArrowLeft className="me-1" /> Back to Reports
                </Button>
              </div>
            </div>
            <hr className="mt-0 mb-0" />

            <div className="card-body">
              {/* Filters Section */}
              <div className="filters-section p-3 bg-light rounded-3">
                <Row className="g-3">
                  <Col md={4}>
                    <Form.Group controlId="outletSelect">
                      <OutletSelect
                        
                        value={selectedOutlet}
                        onChange={(option) => {
                          console.log("Selected Outlet :", option);
                          setSelectedOutlet(option);
                        }}
                        required={true}
                      />

                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group controlId="outletSelect">
                      <Form.Label className="fw-semibold">
                        Select Order Status <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        value={orderStatus}
                        onChange={(e) => setOrderStatus(e.target.value)}
                        className="border-secondary"
                      >
                        <option value="">All</option>
                        <option value="CONFIRMED" >CONFIRMED</option>
                        <option value="CANCELLED" >CANCELLED</option>
                        <option value="COMPLETED" >COMPLETED</option>
                        <option value="DELIVERED" >DELIVERED</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group controlId="outletSelect">
                      <Form.Label className="fw-semibold">
                        Select Order Type <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        value={orderType}
                        onChange={(e) => setOrderType(e.target.value)}
                        className="border-secondary"
                      >
                        <option value="">All</option>
                        <option value="APP" >APP/WEBSITE ORDERS</option>
                        <option value="KIOSK" >KIOSK ORDERS</option>
                        <option value="SUBSCRIBED" >SUBSCRIPTION ORDERS</option>
                        <option value="COMPLIMENTARY" >COMPLIMENTARY ORDERS</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group controlId="datePicker">
                      <Form.Label className="fw-semibold">
                        Select Date <span className="text-danger">*</span>
                      </Form.Label>
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => {
                          setStartDate(date);
                          setEndDate(date);
                          if (date && endDate && date.getTime() !== endDate.getTime()) {
                            setError("Start Date and End Date must be the same");
                          } else {
                            setError(null);
                          }
                        }}
                        dateFormat="dd-MM-yyyy"
                        placeholderText="Select Date"
                        className="form-control border-secondary"
                      />
                    </Form.Group>
                  </Col>

                  {/* <Col md={2}>
                    <Form.Group controlId="datePicker">
                      <Form.Label className="fw-semibold">
                        Select End Date <span className="text-danger">*</span>
                      </Form.Label>
                      <DatePicker
                        selected={endDate}
                        onChange={(date) => {
                          setEndDate(date);
                          if (date && endDate && date.getTime() !== endDate.getTime()) {
                            setError("Start Date and End Date must be the same");
                          } else {
                            setError(null);
                          }
                        }}
                        dateFormat="dd-MM-yyyy"
                        placeholderText="Select Date"
                        className="form-control border-secondary"
                      />
                    </Form.Group>
                  </Col> */}

                  <Col md={2}>
                    <Form.Label className="fw-light text-light">
                      .
                    </Form.Label>
                    <Button
                      variant="primary"
                      className="w-100 py-2"
                      onClick={handleSubmit}
                      disabled={subBtnLoading || selectedOutlet === "" || startDate === null}
                    >
                      {subBtnLoading ? (
                        <Spinner size="sm" animation="border" />
                      ) : (
                        "Generate Report"
                      )}
                    </Button>
                  </Col>
                </Row>
              </div>

              {/* Search and Actions Section */}
              <div className="actions-section mb-2 p-3 bg-light rounded-3">
                <Row className="g-3 align-items-center">
                  <Col md={6}>
                    <InputGroup>
                      <FormControl
                        type="text"
                        placeholder="Search by Name, Order Number or Mobile"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        className="border-secondary"
                      />
                      <Button
                        variant="outline-secondary"
                        onClick={handleSubmit}
                        disabled={selectedOutlet === "" || startDate === null}
                      >
                        <i className="bi bi-search me-3"></i>Search
                      </Button>
                    </InputGroup>
                  </Col>

                  <Col md={3}>
                    <Button
                      variant="outline-primary"
                      className="w-100"
                      onClick={handleSubmit}
                      disabled={selectedOutlet === "" || startDate === null}
                    >
                      {subBtnLoading ? (
                        <Spinner size="sm" animation="border" />
                      ) : (
                        "Refresh Results"
                      )}
                    </Button>
                  </Col>

                  <Col md={3}>
                    <Button
                      variant="outline-success"
                      className="w-100 fw-semibold"
                      disabled={downloadBtnLoading || clicked === false || filteredData?.length === 0}
                      onClick={handleDownloadExcel}
                    >
                      <FileEarmarkSpreadsheet className=" me-2" />
                      {downloadBtnLoading ? (
                        <Spinner size="sm" animation="border" />
                      ) : (
                        "Download Excel"
                      )}
                    </Button>
                  </Col>
                </Row>
              </div>

              {/* Totals Cards Section - NEW ADDITION */}
              {/* Alternative: Compact Cards Layout */}
              {clicked && filteredData?.length > 0 && (
                <div className="compact-cards-section mb-3 d-block"> {/* Add 'd-block' to use this version instead */}
                  <Row className="g-2">
                    <Col md={12}>
                      <Card className={`border-0 ${skin === "dark" ? "bg-dark text-light" : "bg-light"}`}>
                        <Card.Body className="py-2">
                          <Row className="text-center">
                            <Col md={3} className="border-end">
                              <small className={`text-muted ${skin === "dark" ? "text-light" : ""}`}>Total Orders</small>
                              <h5 className="mb-0 fw-bold mt-1">{totalRecords}</h5>
                            </Col>
                            <Col md={3} className="border-end">
                              <small className={`text-muted ${skin === "dark" ? "text-light" : ""}`}>Total Taxable</small>
                              <h5 className="mb-0 fw-bold mt-1 text-success">₹{ordersTotalTaxable?.toFixed(2)}</h5>
                            </Col>
                            <Col md={3} className="border-end">
                              <small className={`text-muted ${skin === "dark" ? "text-light" : ""}`}>Total Discount</small>
                              <h5 className="mb-0 fw-bold mt-1 text-warning">₹{ordersTotalDiscountAmt?.toFixed(2)}</h5>
                            </Col>
                            <Col md={3}>
                              <small className={`text-muted ${skin === "dark" ? "text-light" : ""}`}>Grand Total</small>
                              <h5 className="mb-0 fw-bold mt-1 text-primary">₹{ordersGrandTotal?.toFixed(2)}</h5>
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </div>
              )}

              {/* Results Section */}
              {clicked === false ? (
                <div className="d-flex justify-content-center align-items-center py-5 my-5">
                  <div className="text-center">
                    <i className="bi bi-clipboard2-data fs-1 text-muted"></i>
                    <h5 className="text-muted mt-3">
                      Please select an outlet and date to view orders
                    </h5>
                  </div>
                </div>
              ) : (
                <>
                  {/* Pagination Controls - Top */}
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex align-items-center">
                      <span className="me-2 text-muted">Show</span>
                      <Form.Select
                        style={{ width: "auto" }}
                        value={recordsPerPage}
                        onChange={(e) => setRecordsPerPage(Number(e.target.value))}
                        className="border-secondary"
                      >
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={200}>200</option>
                      </Form.Select>
                      <span className="ms-2 text-muted">entries</span>
                    </div>
                    <Pagination className="mb-0">
                      <Pagination.Prev
                        disabled={currentPage === 1}
                        onClick={() => handlePageChange(currentPage - 1)}
                      />
                      {renderPaginationItems()}
                      <Pagination.Next
                        disabled={currentPage === totalPages}
                        onClick={() => handlePageChange(currentPage + 1)}
                      />
                    </Pagination>
                  </div>

                  {/* Orders Table */}
                  <div className="table-responsive border rounded-3">
                    <Table striped bordered hover className={`mb-0 ${skin === "dark" ? "table-dark" : ""}`}>
                      <thead className={`${skin === "dark" ? "bg-dark" : "bg-light"}`}>
                        <tr>
                          <th width="50">#</th>
                          <th width="120">Order No</th>
                          <th>Customer Details</th>
                          <th width="140">Status</th>
                          {/* New Cool Arrival Column */}
                          <th width="150" className="text-center">Arrival</th>
                          <th width="160">Date & Time</th>
                          <th width="120">Coupon</th>
                          <th width="100" className="text-end">Taxable</th>
                          <th width="100" className="text-end">Tax</th>
                          <th width="100" className="text-end">Discount</th>
                          <th width="120" className="text-end">Total</th>
                          <th width="100" className="text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="12" className="text-center py-4">
                              <Spinner animation="border" variant="primary" />
                              <p className="mt-2 mb-0">Loading orders...</p>
                            </td>
                          </tr>
                        ) : filteredData?.length > 0 ? (
                          <>
                            {filteredData?.map((orderData, index) => (
                              <tr key={index} style={{ cursor: 'pointer' }}>
                                <td className="text-muted" onClick={() => viewOrderDetails(orderData)}>
                                  {(currentPage - 1) * recordsPerPage + index + 1}
                                </td>
                                <td onClick={() => viewOrderDetails(orderData)}>
                                  <span className="fw-semibold" >
                                    {orderData?.order?.order_sequence}
                                    {orderData?.order?.order_no}
                                  </span>
                                  {orderData?.order?.subscriptionId && (
                                    <span className="badge bg-success bg-opacity-10 text-success border border-success">
                                      Subscription
                                    </span>
                                  )}
                                </td>
                                <td onClick={() => viewOrderDetails(orderData)}>
                                  {(orderData?.order?.outletUser && orderData?.order?.paymentMode === "COMPLIMENTARY") ? (
                                    <>
                                      <div className="fw-semibold">
                                        {orderData?.order?.outletUser?.name}
                                      </div>
                                      <div className="text-primary small">
                                        {orderData?.order?.outletUser?.mobile}
                                      </div>
                                      <span className="badge bg-info mt-1">Complimentary</span>
                                    </>
                                  ) : (orderData?.order?.outletUser && orderData?.order?.paymentMode !== "COMPLIMENTARY") ? (
                                    <>
                                      <div className="fw-semibold">
                                        {orderData?.order?.outletUser?.name}
                                      </div>
                                      <div className="text-primary small">
                                        {orderData?.order?.outletUser?.mobile}
                                      </div>
                                      <span className="badge bg-primary mt-1">POS CREATED</span>
                                    </>
                                  ) : orderData?.order?.kioskUser ? (
                                    <>
                                      <div className="fw-semibold">
                                        {orderData?.order?.kioskUser?.name}
                                      </div>
                                      <div className="text-primary small">
                                        {orderData?.order?.kioskUser?.phone}
                                      </div>
                                      <span className="badge bg-warning text-dark mt-1">Kiosk</span>
                                    </>
                                  ) : (
                                    <>
                                      <div className="fw-semibold">
                                        {orderData?.order?.user?.name}
                                      </div>
                                      <div className="text-primary small">
                                        {orderData?.order?.user?.mobile}
                                      </div>
                                    </>
                                  )}
                                </td>
                                <td className="text-center" onClick={() => viewOrderDetails(orderData)}>
                                  <Badge
                                    bg={getStatusBadgeColor(orderData?.order?.orderStatus)}
                                    className="py-1 px-2"
                                  >
                                    {orderData?.order?.orderStatus}
                                  </Badge>
                                </td>

                                {/* === Arrival Status Column - Cool Version === */}
                                <td className="text-center" onClick={() => viewOrderDetails(orderData)}>
                                  {orderData?.order?.orderArrivalStatus === "DELAYED" ? (
                                    <div
                                      className="d-inline-flex align-items-center gap-2 px-3 py-2"
                                      style={{
                                        background: "rgba(220,53,69,0.1)",
                                        color: "#dc3545",
                                        borderRadius: "9px",
                                        fontSize: "11px",
                                        fontWeight: 500,
                                      }}
                                    >
                                      <i className="bi bi-clock-history"></i>
                                      <div className="text-start">
                                        <div style={{ fontWeight: 600, lineHeight: "1" }}>Delayed</div>
                                        <div style={{ fontSize: "10px" }}>
                                          +{orderData?.order?.delayedArrival} min
                                        </div>
                                      </div>
                                    </div>
                                  ) : orderData?.order?.orderArrivalStatus === "EARLY" ? (
                                    <div
                                      className="d-inline-flex align-items-center gap-2 px-3 py-2"
                                      style={{
                                        background: "rgba(25,135,84,0.1)",
                                        color: "#198754",
                                        borderRadius: "9px",
                                        fontSize: "11px",
                                        fontWeight: 500,
                                      }}
                                    >
                                      <i className="bi bi-lightning-charge-fill"></i>
                                      <div className="text-start">
                                        <div style={{ fontWeight: 600, lineHeight: "1" }}>Early</div>
                                        <div style={{ fontSize: "10px" }}>
                                          -{orderData?.order?.earlyArrival} min
                                        </div>
                                      </div>
                                    </div>
                                  ) : orderData?.order?.orderArrivalStatus === "ON_TIME" ? (
                                    <div
                                      className="d-inline-flex align-items-center gap-2 px-3 py-2"
                                      style={{
                                        background: "rgba(13,110,253,0.1)",
                                        color: "#0d6efd",
                                        borderRadius: "9px",
                                        fontSize: "11px",
                                        fontWeight: 500,
                                      }}
                                    >
                                      <i className="bi bi-check-circle"></i>
                                      <div style={{ fontWeight: 600 }}>On Time</div>
                                    </div>
                                  ) : (
                                    // <span className="text-muted fs-6">—</span>
                                    <div
                                      className="d-inline-flex align-items-center gap-2 px-3 py-2"
                                      style={{
                                        background: "rgba(13,110,253,0.1)",
                                        color: "#0d6efd",
                                        borderRadius: "9px",
                                        fontSize: "11px",
                                        fontWeight: 500,
                                      }}
                                    >
                                      <i className="bi bi-check-circle"></i>
                                      <div style={{ fontWeight: 600 }}>On Time</div>
                                    </div>
                                  )}
                                </td>

                                <td onClick={() => viewOrderDetails(orderData)}>
                                  <div className="small">
                                    {new Date(orderData?.order?.createdAt).toLocaleDateString("en-US", {
                                      year: "numeric",
                                      month: "short",
                                      day: "numeric",
                                    })}
                                  </div>
                                  <div className="text-muted small" onClick={() => viewOrderDetails(orderData)}>
                                    {new Date(orderData?.order?.createdAt).toLocaleTimeString("en-US", {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: true,
                                    })}
                                  </div>
                                </td>
                                <td className="text-center" onClick={() => viewOrderDetails(orderData)}>
                                  {orderData?.order?.coupon ? (
                                    <span className="badge bg-success bg-opacity-10 text-success">
                                      {orderData?.order?.coupon?.couponCode}
                                    </span>
                                  ) : (
                                    <span className="text-muted">--</span>
                                  )}
                                </td>
                                <td className="text-end fw-semibold" onClick={() => viewOrderDetails(orderData)}>
                                  ₹{orderData?.order?.totalTaxable?.toFixed(2)}
                                </td>
                                <td className="text-end" onClick={() => viewOrderDetails(orderData)}>
                                  ₹{orderData?.order?.totalTaxAmount?.toFixed(2)}
                                </td>
                                <td className="text-end" onClick={() => viewOrderDetails(orderData)}>
                                  ₹{orderData?.order?.totalDiscount?.toFixed(2)}
                                </td>
                                <td className="text-end fw-bold text-primary" onClick={() => viewOrderDetails(orderData)}>
                                  ₹{orderData?.order?.grandTotal?.toFixed(2)}
                                </td>
                                <td className="text-center">
                                  <Dropdown>
                                    <Dropdown.Toggle
                                      variant="outline-primary"
                                      size="sm"
                                      id="dropdown-basic"
                                      className="px-3"
                                    >
                                      Actions
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                      <Dropdown.Item
                                        onClick={() => viewOrderDetails(orderData)}
                                      >
                                        <i className="bi bi-eye me-2 text-success"></i> View Details
                                      </Dropdown.Item>
                                      {/* {( (reportAccess?.includes("OrdersReport:update") || email === "contact@xpansecafe.com") && orderData?.order?.orderStatus !== "CANCELLED") && (
                                              <Dropdown.Item 
                                                onClick={() => handleOpenCancelOrderModal(orderData)}
                                              >
                                                <i className="bi bi-x-circle me-2 text-danger"></i> Cancel Order
                                              </Dropdown.Item>
                                            )} */}
                                      {((reportAccess?.includes("OrdersReport:update") || email === "contact@xpansecafe.com") &&
                                        (orderData?.order?.orderStatus !== "CANCELLED" && new Date(orderData?.order?.createdAt).toDateString() === currentDate.toDateString()) && orderData?.order?.paymentMode !== "COMPLIMENTARY") && (
                                          <Dropdown.Item
                                            onClick={() => handleOpenCancelOrderModal(orderData)}
                                          >
                                            <i className="bi bi-x-circle me-2 text-danger"></i> Cancel Order
                                          </Dropdown.Item>
                                        )}
                                      <Dropdown.Item
                                        onClick={() => handlePrintInvoice(orderData)}
                                      >
                                        <i className="bi bi-receipt me-2 text-primary"></i> Print Invoice
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </td>
                              </tr>
                            ))}

                            {/* Grand Total Row */}
                            {currentPage === lastPage && (
                              <tr className="fw-bold">
                                <td colSpan="7" className="text-end">
                                  Grand Total:
                                </td>
                                <td className="text-end">₹ {ordersTotalTaxable?.toFixed(2)}</td>
                                <td className="text-end">₹ {ordersTotalTaxAmt?.toFixed(2)}</td>
                                <td className="text-end">₹ {ordersTotalDiscountAmt?.toFixed(2)}</td>
                                <td className="text-end text-success">₹ {ordersGrandTotal?.toFixed(2)}</td>
                                <td></td>
                              </tr>
                            )}
                          </>
                        ) : (
                          <tr>
                            <td colSpan="11" className="text-center py-4">
                              <i className="bi bi-exclamation-circle fs-4 text-muted"></i>
                              <p className="mt-2 mb-0 text-muted">
                                {errorMsg || "No orders found for the selected criteria"}
                              </p>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>

                  {/* Pagination Controls - Bottom */}
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div className="text-muted">
                      Showing {(currentPage - 1) * recordsPerPage + 1} to{" "}
                      {Math.min(currentPage * recordsPerPage, filteredData?.length)} of{" "}
                      {filteredData?.length} entries
                    </div>
                    <Pagination>
                      <Pagination.Prev
                        disabled={currentPage === 1}
                        onClick={() => handlePageChange(currentPage - 1)}
                      />
                      {renderPaginationItems()}
                      <Pagination.Next
                        disabled={currentPage === totalPages}
                        onClick={() => handlePageChange(currentPage + 1)}
                      />
                    </Pagination>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        {/* Cancel Order Modal */}
        {openCancelOrderModal && (
          <Modal
            show={openCancelOrderModal}
            onHide={handleCloseCancelOrderModal}
            size="lg"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Cancel Order</Modal.Title>
            </Modal.Header>

            <Form onSubmit={
              cancelOrderData?.order?.subscriptionId ? handleCancelSubsOrder : handleCancelNormalOrder
            }
            >
              <Modal.Body>
                {/* {error && <Alert variant="danger">{error}</Alert>} */}

                <Row className="mb-3">
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Refund Type <span className="text-danger">*</span></Form.Label>
                      <div>
                        <Form.Check
                          inline
                          type="radio"
                          label="Instant Refund"
                          name="refundType"
                          value="INSTANT"
                          checked={refundType === 'INSTANT'}
                          onChange={(e) => setRefundType(e.target.value)}
                          id="refund-instant"
                        />
                        <Form.Check
                          inline
                          type="radio"
                          label="Normal Refund"
                          name="refundType"
                          value="NORMAL"
                          checked={refundType === 'NORMAL'}
                          onChange={(e) => setRefundType(e.target.value)}
                          id="refund-normal"
                        />
                      </div>
                    </Form.Group>
                  </Col>

                  {/* <Col md={4}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">Stock Management <span className="text-danger">*</span></Form.Label>
                            <Form.Check
                              type="checkbox"
                              label="Restore items to inventory"
                              checked={isStockRefund}
                              onChange={(e) => setIsStockRefund(e.target.checked)}
                              id="stock-refund"
                            />
                          </Form.Group>
                        </Col> */}

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Stock Management <span className="text-danger">*</span>
                      </Form.Label>
                      <div>
                        <Form.Check
                          type="radio"
                          label="Restore items to inventory"
                          name="stock-refund"
                          checked={isStockRefund === true}
                          onChange={() => setIsStockRefund(true)}
                          id="stock-refund-true"
                        />
                        <Form.Check
                          type="radio"
                          label="Do not restore items to inventory"
                          name="stock-refund"
                          checked={isStockRefund === false}
                          onChange={() => setIsStockRefund(false)}
                          id="stock-refund-false"
                        />
                      </div>
                    </Form.Group>
                  </Col>


                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Approved From <span className="text-danger">*</span></Form.Label>
                      <Select
                        options={adminUserOptions}
                        value={adminUserOptions.find(option => option.value === selectedAdminUser)}
                        onChange={(selectedOption) => {
                          const selectCategory = selectedOption?.value;
                          setSelectedAdminUser(selectCategory);
                        }}
                        isClearable
                        styles={customStyles}
                        placeholder="Select Approver"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold">Reason for Cancellation <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    placeholder="Please provide a reason for canceling this order"
                    required
                  />
                </Form.Group>

                {/* <div className="text-muted small">
                        <p><strong>Note:</strong></p>
                        <ul>
                          <li>Instant refunds are processed immediately to the original payment method</li>
                          <li>Normal refunds may take 5-7 business days to process</li>
                          <li>Restoring items to inventory will make them available for purchase again</li>
                        </ul>
                      </div> */}
              </Modal.Body>

              <Modal.Footer>
                <Button
                  variant="outline-secondary"
                  onClick={handleCloseCancelOrderModal}
                  disabled={cancelBtnLoading}
                >
                  Cancel
                </Button>
                <Button
                  variant="danger"
                  type="submit"
                  disabled={cancelBtnLoading || !reason.trim()}
                >
                  {cancelBtnLoading ? <Spinner size="sm" animation="border" /> : 'Confirm Cancellation'}
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>
        )}

        {/* Modal for Viewing Order Details */}
        <Modal
          show={viewDetailsModal}
          onHide={closeModal}
          size="lg"
          centered
        >
          <Modal.Header closeButton className="border-0">
            <Modal.Title className="w-100 text-center">
              {selectedOrder?.order?.paymentMode === "SUBSCRIBED" ? (
                <div className="d-flex justify-content-center align-items-center">
                  <span className="fs-4 me-2">🔄</span>
                  <span className="fw-bold text-primary">SUBSCRIPTION ORDER DETAILS</span>
                  <span className="fs-4 ms-2">📦</span>
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center">
                  <span className="fs-4 me-2">🛒</span>
                  <span className="fw-bold text-muted">ORDER DETAILS</span>
                  <span className="fs-4 ms-2">🧾</span>
                </div>
              )}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedOrder ? (
              <div className="p-3">
                <Row className="mb-2">
                  <Col xs={4}>
                    <h6>Order No:</h6>
                    <p>{selectedOrder?.order?.order_sequence}{selectedOrder?.order?.order_no}</p>
                  </Col>
                  <Col xs={4}>
                    <h6>Order Type :</h6>
                    <p>{selectedOrder?.order?.ordersType}</p>
                  </Col>
                  <Col xs={4}>
                    <h6>Outlet Name :</h6>
                    <p>
                      {selectedOrder?.orderStatusLogs[0]?.outlet?.name}
                    </p>
                  </Col>

                </Row>
                <Row className="mb-2">
                  <Col xs={4}>
                    <h6>Date & Time:</h6>
                    <p>
                      {new Date(selectedOrder?.order?.createdAt).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })}{" / "}
                      {new Date(selectedOrder?.order?.createdAt).toLocaleTimeString('en-US', {
                        hour: 'numeric',
                        minute: 'numeric',
                        hour12: true,
                      })}
                    </p>
                  </Col>
                  <Col xs={4}>
                    <h6>User Name :</h6>
                    <p>
                      {selectedOrder?.order?.outletUser
                        ? `${selectedOrder?.order?.outletUser?.name}`
                        : selectedOrder?.order?.kioskUser
                          ? `${selectedOrder?.order?.kioskUser?.name} [Kiosk User]`
                          : selectedOrder?.order?.user?.name}
                    </p>
                  </Col>
                  <Col xs={4}>
                    <h6>Mobile Number :</h6>
                    <p>
                      {selectedOrder?.order?.outletUser
                        ? selectedOrder?.order?.outletUser?.mobile
                        : selectedOrder?.order?.kioskUser
                          ? selectedOrder?.order?.kioskUser?.phone
                          : selectedOrder?.order?.user?.mobile}
                    </p>
                  </Col>

                  <Col xs={4}>
                    <h6>Source :</h6>
                    <p>
                      {selectedOrder?.order?.source}
                      {/* {selectedOrder?.order?.outletUser
                              ? "Complimentary Order"
                              : selectedOrder?.order?.kioskUser
                              ? "Kiosk"
                              : "APP"} */}
                    </p>
                  </Col>
                  <Col xs={4}>
                    <h6>Status :</h6>
                    <Badge
                      bg={
                        selectedOrder?.order?.orderStatus === "COMPLETED"
                          ? "success"
                          : selectedOrder?.order?.orderStatus === "DELIVERED"
                            ? "primary"
                            : selectedOrder?.order?.orderStatus === "CONFIRMED"
                              ? "secondary"
                              : selectedOrder?.order?.orderStatus === "READY-TO-PICK"
                                ? "warning"
                                : "danger"
                      }
                      className="py-1 px-2"
                    >
                      {selectedOrder?.order?.orderStatus}
                    </Badge>
                  </Col>
                  <Col xs={4}>
                    <h6>Payment Gateway :</h6>
                    <p className="fw-semibold" style={{ color: selectedOrder?.order?.paymentGatewayProvider === "RAZORPAY" ? 'orangered' : 'blueviolet' }}>
                      {selectedOrder?.order?.paymentMode === "COMPLIMENTARY" ? "COMPLIMENTARY" : selectedOrder?.order?.paymentGatewayProvider} <br />
                      {selectedOrder?.order?.razorpayOrderId &&
                        <span className="text-muted pt-0" style={{ fontSize: '12px' }}>[{selectedOrder?.order?.razorpayOrderId}]</span>
                      }
                    </p>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col xs={4}>
                    <h6>Payment Status :</h6>
                    <Badge
                      bg={
                        selectedOrder.order?.paymentStatus === "PAID"
                          ? "success"
                          : "danger"
                      }
                      className="py-1 px-2"
                    >
                      {selectedOrder?.order?.paymentStatus}
                    </Badge>
                  </Col>
                  <Col xs={4}>
                    <h6>Pickup Option :</h6>
                    <p>{selectedOrder?.order?.pickupOption}</p>
                  </Col>
                  <Col xs={4}>
                    <h6>Coupon Applied :</h6>
                    <p>{selectedOrder?.order?.coupon ? "YES" : "NO"}</p>
                  </Col>
                  <Col xs={4}>
                    <h6>Arrival Status :</h6>
                    {selectedOrder?.order?.orderArrivalStatus === "DELAYED" ? (
                      <div className="d-inline-flex align-items-center gap-2 px-3 py-2"
                        style={{ background: "rgba(220,53,69,0.1)", color: "#dc3545", borderRadius: "9px", fontSize: "12px", fontWeight: 500 }}>
                        <i className="bi bi-clock-history"></i>
                        <div>
                          <div style={{ fontWeight: 600 }}>Delayed</div>
                          <div style={{ fontSize: "11px" }}>+{selectedOrder?.order?.delayedArrival} min late</div>
                        </div>
                      </div>
                    ) : selectedOrder?.order?.orderArrivalStatus === "EARLY" ? (
                      <div className="d-inline-flex align-items-center gap-2 px-3 py-2"
                        style={{ background: "rgba(25,135,84,0.1)", color: "#198754", borderRadius: "9px", fontSize: "12px", fontWeight: 500 }}>
                        <i className="bi bi-lightning-charge-fill"></i>
                        <div>
                          <div style={{ fontWeight: 600 }}>Early</div>
                          <div style={{ fontSize: "11px" }}>-{selectedOrder?.order?.earlyArrival} min ahead</div>
                        </div>
                      </div>
                    ) : (
                      <div className="d-inline-flex align-items-center gap-2 px-3 py-2"
                        style={{ background: "rgba(13,110,253,0.1)", color: "#0d6efd", borderRadius: "9px", fontSize: "12px", fontWeight: 500 }}>
                        <i className="bi bi-check-circle-fill"></i>
                        <div style={{ fontWeight: 600 }}>On Time</div>
                      </div>
                    )}
                  </Col>
                </Row>
                {/* <Row className="mb-2">
                        
                      </Row> */}

                {selectedOrder?.order?.coupon && (
                  <Row className="mb-2">
                    <Col xs={4} md={4}>
                      <h6>Coupon Name :</h6>
                      <p>{selectedOrder?.order?.coupon?.title}</p>
                    </Col>
                    <Col xs={4} md={4}>
                      <h6>Coupon Code :</h6>
                      <p className="text-danger">{selectedOrder?.order?.coupon?.couponCode}</p>
                    </Col>
                    <Col xs={4} md={4}>
                      <h6>Usage Type :</h6>
                      <p>{selectedOrder?.order?.coupon?.usageType}</p>
                    </Col>
                  </Row>
                )}

                {selectedOrder?.order?.comments && (
                  <Row className="mb-2">
                    <Col xs={12} md={12}>
                      <h6>Remark :</h6>
                      <p>{selectedOrder?.order?.comments}</p>
                    </Col>
                  </Row>
                )}

                <Row className="mb-1">
                  <Col xs={12}>
                    <h6>Ordered Items :</h6>
                    <Table striped bordered hover responsive>
                      <thead>
                        <tr>
                          <th className="fw-semibold">Product</th>
                          <th className="text-center fw-semibold">Quantity</th>
                          <th className="text-center fw-semibold">Price</th>
                          <th className="text-center fw-semibold">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedOrder?.orderItems?.map((item) => (
                          <tr key={item._id}>
                            <td>{item?.product?.name}
                              {item?.addons?.length > 0 && (
                                <ul style={{ fontSize: '14px' }}>
                                  {item.addons.map((addon) => (
                                    <li key={addon._id}>
                                      {addon.selectedValue} (₹{addon.price})
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </td>
                            <td className="text-center">{item?.quantity}</td>
                            <td className="text-end">
                              ₹{selectedOrder?.order?.coupon?.isMrpDiscount && item.discount > 0 ? item.mrpRate.toFixed(2) : item.rate.toFixed(2)}
                              {item?.addons?.length > 0 && (
                                <ul style={{ fontSize: '14px', listStyleType: 'none' }}>
                                  {item?.addons?.map((addon) => (
                                    <li key={addon._id}>
                                      + (₹{addon?.price})
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </td>
                            <td className="text-end">
                              ₹{getItemTotal(item).toFixed(2)}
                            </td>
                          </tr>
                        ))}

                        {selectedOrder?.order?.platformFees !== 0 && (
                          <tr>
                            <td colSpan={3} className="text-end" style={{ fontSize: '14px' }}>
                              Platform Fees:
                            </td>
                            <td style={{ fontSize: '14px' }} className="text-end">
                              ₹ {Number(selectedOrder?.order?.platformFees).toFixed(2)}
                            </td>
                          </tr>
                        )}

                        {selectedOrder?.order?.packingCharges !== 0 && (
                          <tr>
                            <td colSpan={3} className="text-end" style={{ fontSize: '14px' }}>Packing Fees:</td>
                            <td style={{ fontSize: '14px' }} className="text-end">
                              ₹ {selectedOrder?.order?.packingCharges ? selectedOrder?.order?.packingCharges?.toFixed(2) : "0"}
                            </td>
                          </tr>
                        )}

                        {selectedOrder?.order?.deliveryCharges !== 0 && (
                          <tr>
                            <td colSpan={3} className="text-end" style={{ fontSize: '14px' }}>Delivery Charges:</td>
                            <td style={{ fontSize: '14px' }} className="text-end">
                              ₹ {selectedOrder?.order?.deliveryCharges?.toFixed(2)}
                            </td>
                          </tr>
                        )}

                        <tr>
                          <td colSpan={3} className="text-end" style={{ fontSize: '14px' }}>Total :</td>
                          <td style={{ fontSize: '14px' }} className="text-end">
                            ₹ {calculateTotal()}
                          </td>
                        </tr>

                        <tr style={{ borderBottom: '1px solid #9e9b9b' }}>
                          <td colSpan={3} className="text-end" style={{ fontSize: '14px' }}>Total Discount:</td>
                          <td style={{ fontSize: '14px' }} className="text-end">
                            (-) ₹ {selectedOrder?.order?.totalDiscount?.toFixed(2)}
                          </td>
                        </tr>

                        <tr>
                          <td colSpan={3} className="text-end" style={{ fontSize: '14px' }}></td>
                          <td style={{ fontSize: '14px' }} className="text-end text-muted fw-semibold">
                            ₹ {(calculateTotal() - (selectedOrder?.order?.totalDiscount || 0)).toFixed(2)}
                          </td>
                        </tr>

                        <tr style={{ borderBottom: '1px solid #000' }}>
                          <td colSpan={3} className="text-end" style={{ fontSize: '14px' }}>Total Tax Amount:</td>
                          <td style={{ fontSize: '14px' }} className="text-end">
                            (+) ₹ {selectedOrder?.order?.totalTaxAmount?.toFixed(2)}
                          </td>
                        </tr>

                        <tr style={{ borderBottom: '1px solid #000' }}>
                          <td colSpan={3} className="text-end"><strong>Grand Total:</strong></td>
                          <td className="text-end fw-semibold">
                            ₹ {selectedOrder?.orderItems?.reduce((total, item) => total + item.grandTotal, 0).toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                </Row>

                <Row className="mb-1">
                  <Col xs={12}>
                    <h6>Order Status Log :</h6>
                    <Table striped bordered hover responsive>
                      <thead>
                        <tr>
                          <th className="fw-semibold">Order Status</th>
                          <th className="fw-semibold">Time</th>
                          <th className="fw-semibold">Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedOrder?.orderStatusLogs?.length > 0 ? (
                          selectedOrder.orderStatusLogs.map((log) => (
                            <tr key={log._id}>
                              <td>
                                <Badge
                                  bg={
                                    log.orderStatus === "COMPLETED"
                                      ? "success"
                                      : log.orderStatus === "DELIVERED"
                                        ? "primary"
                                        : log.orderStatus === "CONFIRMED"
                                          ? "secondary"
                                          : log.orderStatus === "READY-TO-PICK"
                                            ? "warning"
                                            : log.orderStatus === "CANCELLED"
                                              ? "danger"
                                              : "dark"
                                  }
                                  className="py-1 px-2"
                                >
                                  {log.orderStatus}
                                </Badge>
                              </td>
                              <td>
                                {new Date(log.createdAt).toLocaleTimeString('en-US', {
                                  hour: 'numeric',
                                  minute: 'numeric',
                                  hour12: true,
                                })}
                              </td>
                              <td>
                                {new Date(log.createdAt).toLocaleDateString('en-US', {
                                  year: 'numeric',
                                  month: 'long',
                                  day: 'numeric',
                                })}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={3} className="text-center">
                              No order status logs available.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </div>
            ) : (
              <p>No order details available.</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default OrdersReport;
